module.exports = __webpack_public_path__ + "static/media/scroll4_phone4.ab6ab28f.png";